// API URLs
export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;


if (!SUPABASE_URL) {
    alert('VITE_SUPABASE_URLが定義されていません');
    throw new Error('VITE_SUPABASE_URL is not defined');
}

// Supabase configuration
export const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!SUPABASE_ANON_KEY) {
    alert('VITE_SUPABASE_ANON_KEYが定義されていません');
    throw new Error('VITE_SUPABASE_ANON_KEY is not defined');
}

// Stripe configuration

const viteEnv = import.meta.env.VITE_ENVIRONMENT || 'development';

type StripeEnvKeys = {
    PUBLISHABLE_KEY: string;
    BASIC_PLAN_PRICE_ID: string;
    STANDARD_PLAN_PRICE_ID: string;
    PROFESSIONAL_PLAN_PRICE_ID: string;
    ENTERPRISE_PLAN_PRICE_ID: string;
    CREDIT_PACK_500_PRICE_ID: string;
    CREDIT_PACK_1000_PRICE_ID: string;
};

const envMap: Record<string, StripeEnvKeys> = {
    production: {
        PUBLISHABLE_KEY: 'VITE_STRIPE_LIVE_PUBLISHABLE_KEY',
        BASIC_PLAN_PRICE_ID: 'VITE_STRIPE_BASIC_PLAN_PRICE_ID',
        STANDARD_PLAN_PRICE_ID: 'VITE_STRIPE_STANDARD_PLAN_PRICE_ID',
        PROFESSIONAL_PLAN_PRICE_ID: 'VITE_STRIPE_PROFESSIONAL_PLAN_PRICE_ID',
        ENTERPRISE_PLAN_PRICE_ID: 'VITE_STRIPE_ENTERPRISE_PLAN_PRICE_ID',
        CREDIT_PACK_500_PRICE_ID: 'VITE_STRIPE_CREDIT_PACK_500_PRICE_ID',
        CREDIT_PACK_1000_PRICE_ID: 'VITE_STRIPE_CREDIT_PACK_1000_PRICE_ID',
    },
    development: {
        PUBLISHABLE_KEY: 'VITE_STRIPE_TEST_PUBLISHABLE_KEY',
        BASIC_PLAN_PRICE_ID: 'VITE_STRIPE_DEV_BASIC_PLAN_PRICE_ID',
        STANDARD_PLAN_PRICE_ID: 'VITE_STRIPE_DEV_STANDARD_PLAN_PRICE_ID',
        PROFESSIONAL_PLAN_PRICE_ID: 'VITE_STRIPE_DEV_PROFESSIONAL_PLAN_PRICE_ID',
        ENTERPRISE_PLAN_PRICE_ID: 'VITE_STRIPE_DEV_ENTERPRISE_PLAN_PRICE_ID',
        CREDIT_PACK_500_PRICE_ID: 'VITE_STRIPE_DEV_CREDIT_PACK_500_PRICE_ID',
        CREDIT_PACK_1000_PRICE_ID: 'VITE_STRIPE_DEV_CREDIT_PACK_1000_PRICE_ID',
    },
};

const keys = envMap[viteEnv] || envMap.development;

function getEnvVar(key: string, jpMsg: string) {
    const value = import.meta.env[key];
    if (value == null) {
        alert(`${jpMsg}「${key}」が定義されていません`);
        throw new Error(`${key} is not defined`);
    }
    return value;
}

export const STRIPE_PUBLISHABLE_KEY = getEnvVar(keys.PUBLISHABLE_KEY, '公開キー');
export const STRIPE_BASIC_PLAN_PRICE_ID = getEnvVar(keys.BASIC_PLAN_PRICE_ID, 'ベーシックプランID');
export const STRIPE_STANDARD_PLAN_PRICE_ID = getEnvVar(keys.STANDARD_PLAN_PRICE_ID, 'スタンダードプランID');
export const STRIPE_PROFESSIONAL_PLAN_PRICE_ID = getEnvVar(keys.PROFESSIONAL_PLAN_PRICE_ID, 'プロフェッショナルプランID');
export const STRIPE_ENTERPRISE_PLAN_PRICE_ID = getEnvVar(keys.ENTERPRISE_PLAN_PRICE_ID, 'エンタープライズプランID');
export const STRIPE_CREDIT_PACK_500_PRICE_ID = getEnvVar(keys.CREDIT_PACK_500_PRICE_ID, '500クレジットパックID');
export const STRIPE_CREDIT_PACK_1000_PRICE_ID = getEnvVar(keys.CREDIT_PACK_1000_PRICE_ID, '1000クレジットパックID');

//Load google recaptcha site key
export const RECAPTCHA_SITE_KEY = import.meta.env.VITE_GOOGLE_RECAPTCHA_SITE_KEY || '';
if (!RECAPTCHA_SITE_KEY) {
    alert('VITE_RECAPTCHA_SITE_KEYが定義されていません');
    throw new Error('VITE_RECAPTCHA_SITE_KEY is not defined');
}

// Application constants
export const MAX_IMAGES = 10;
export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB in bytes